
import { animated, useTransition } from "@react-spring/web";
import PropTypes from "prop-types";

const AnimatedPopup = ({
  show,
  children,
  direction = "bottom",
  zIndex = "2000",
}) => {
  let baseStyling;
  let transform;

  switch (direction) {
    case "top":
      baseStyling = {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        zIndex: zIndex,
      };
      transform = "translate3d(0, -100%, 0)";
      break;
    case "right":
      transform = "translate3d(100%, 0, 0)";
      baseStyling = {
        position: "fixed",
        top: "0",
        right: "0",
        height: "100%",
        zIndex: zIndex,
      };
      break;
    case "bottom-minimal":
      transform = "translate3d(0, 100%, 0)";
      baseStyling = {
        position: "fixed",
        bottom: "0",
        left: "0",
        width: "100%",
        zIndex: zIndex,
      };
      break;
    case "bottom":
    default:
      transform = "translate3d(0, 100%, 0)";
      baseStyling = {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        zIndex: zIndex,
      };
      break;
  }

  const transitions = useTransition(show, {
    from: {
      transform,
      ...baseStyling,
    },
    enter: {
      transform: "translate3d(0%, 0%, 0)",
      ...baseStyling,
    },
    leave: {
      transform,
      ...baseStyling,
    },
  });

  return (
    <>
      {transitions((style, show) => (
        <animated.div
          style={{ ...style, ...(show ? {} : { pointerEvents: "none" }) }}
        >
          {show && [children]}
        </animated.div>
      ))}
    </>
  );
};

AnimatedPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.element,
  direction: PropTypes.string,
  zIndex: PropTypes.string,
};

export default AnimatedPopup;